export default "__VITE_ASSET__mYntY_6A__"